import React, { useState } from "react";
import { Link } from "gatsby";
import SbEditable from "storyblok-react";
import NavigationSection from "./NavigationSection";
import FeaturedLink from "./FeaturedLink";
import resolveLink from "src/utils/resolveLink";
import GetCareers from "src/utils/GetCareers"

const NavigationItem = (item) => {
  const [show, setShow] = useState(false);
  return (
    <SbEditable content={item} key={item._uid}>
      {item.navigation_sections.length === 0 && (
        <div className="py-8">
          <Link
            className={`font-display after:bg-red text-blue hover:text-red hover:after:opacity-1 relative cursor-pointer text-base uppercase tracking-[0.02em] transition duration-300 after:absolute after:left-1/2 after:-bottom-1 after:h-[0.20rem] after:w-[0.20rem] after:-translate-x-1/2 after:transform after:rounded-full after:opacity-0 after:transition after:duration-300`}
            to={resolveLink(`/${item.target.cached_url}`)}
          >
            {item.label}
            {item.careers_number &&
              <div className="absolute -top-2 -right-4 bg-red h-4 w-4 flex justify-center items-center text-white text-xs rounded-full">
                <span className="mt-px">
                  {GetCareers('')?.length}
                </span>
              </div>
            }
          </Link>
        </div>
      )}
      {item.navigation_sections.length > 0 && (
        <div
          className="py-8"
          role="button"
          tabIndex={0}
          onMouseEnter={() => {
            setShow(true);
            item.handleDropdownToggled(true);
          }}
          onMouseLeave={() => {
            setShow(false);
            item.handleDropdownToggled(false);
          }}
        >
          <span
            className={`font-display after:bg-red relative cursor-pointer text-base uppercase tracking-[0.02em] transition duration-300 after:absolute after:left-1/2 after:-bottom-1 after:h-[0.20rem] after:w-[0.20rem] after:-translate-x-1/2 after:transform after:rounded-full after:transition after:duration-300 ${
              show ? "text-red after:opacity-1" : "text-blue after:opacity-0"
            }`}
          >
            {item.label}
          </span>
          {item.navigation_sections.length && (
            <div
              className={`fixed left-0 top-[90px] z-10 w-screen origin-top transform cursor-default bg-gray-100 px-12 pt-8 pb-12 transition-all duration-500 ease-in-out ${
                show ? "z-40 scale-y-100 shadow-lg" : "scale-y-0"
              }`}
            >
              <div
                className={`transition-opacity duration-500 ${
                  show ? "opacity-100 delay-300" : "delay-0 opacity-0"
                } ease-in-out`}
              >
                {item.top_level_label && (
                  <div>
                    <Link
                      className="font-display text-blue hover:text-red uppercase tracking-wider transition duration-300"
                      to={resolveLink(`/${item.top_level_link.cached_url}`)}
                    >
                      {item.top_level_label}
                      <i className="fal fa-angle-right ml-2 -mt-px text-xs"></i>
                    </Link>
                    <div className="mt-1 mb-4 h-px bg-gray-300"></div>
                  </div>
                )}
                <div className="flex space-x-8">
                  <div className="max-w-sm flex-1">
                    {item.navigation_sections.map((item, index) => {
                      return <NavigationSection {...item} key={index} />;
                    })}
                  </div>
                  {item.featured_links.map((item, index) => {
                    return <FeaturedLink {...item} key={index} />;
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </SbEditable>
  );
};

export default NavigationItem;
